import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
import { useTranslation } from 'react-i18next';
import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import NavbarItems from './NavbarItems';
import { postLogout } from '@/api/auth/postLogout';
import { langPath } from '@/utils/langPath';
import { useLoading } from '@/context/LoadingContext';
import { getPartnerMe } from '@/api/profile/getPartnerMe';
import { useDispatch } from 'react-redux';
import { auth } from '@/stores/slices/authSlices';
import { useAppSelector } from '@/stores/hooks';
import { getAuthContext } from '@/context/global/globalAuthRef';
import { deleteFcmDeviceToken } from '@/api/fcm/deleteFcmDeviceToken';

const NavBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();
  const fcmToken = useAppSelector((state) => state.fcm.token);

  const onClickLogout = useCallback(async () => {
    startLoading();
    try {
      if (fcmToken) {
        try {
          await deleteFcmDeviceToken({ token: fcmToken });
        } catch (error) {
          console.error('FCM 토큰 삭제 실패:', error);
        }
      }
      await postLogout();
    } finally {
      const authContext = getAuthContext();
      if (authContext) {
        authContext.logout();
      }

      navigate(langPath('/login'), { replace: true });
      stopLoading();
    }
  }, [fcmToken, navigate, startLoading, stopLoading]);

  return (
    <NavContainer>
      <NavbarItems />
      <LogoutWrap onClick={onClickLogout}>
        <img src={Images.LogoutImg} alt="logout-img" />
        <div>{t('logout')}</div>
      </LogoutWrap>
    </NavContainer>
  );
};

export default NavBar;

const NavContainer = styled.nav`
  /* padding: 51px 11px 51px 27px;
  width: 253px; */
  width: 237px;
  padding: 51px 0 0 27px;
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: hidden;
`;

const LogoutWrap = styled.button`
  display: flex;
  align-items: center;
  gap: 18px;
  font-family: ${fonts.family.poppins};
  line-height: 120%;
  font-size: 14px;
  color: #6996f8;
`;
